import classNames from 'classnames/bind';

import PlainCheckbox from 'app/common/ui-next/plain-checkbox';
import Tooltip from 'app/common/ui/Tooltip';
import IconLightCross from 'app/common/icons/IconLightCross';
import EditableProp from 'app/common/ui/EditableProp';
import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog';
import IconRecovery from 'app/common/icons/IconRecovery';
import IconVendingMachine from 'app/common/icons/IconAppGradeBook';

import enhanceCategory from './enhanceCategory';
import type { Lang } from './enhanceCategory';

import styles from './Category.module.scss';
import { SyntheticEvent } from 'react';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import { IconSettings } from 'app/common/icons';


/**
 * Item для разделов "категории меню", "точки продаж" и других подобных,
 * где есть 2 столбца: "текущие" и "удаленные"
 * Поддерживает изменение имени, выделение и кнопки переноса в противоположный столбец
 */


const cx = classNames.bind(styles);

type Props = {
  handleToggleItem: (e: SyntheticEvent<HTMLElement>) => void,
  onDelete: (id: number) => void,
  onRestore: (id: number) => void,
  onSettings?: (id: number, title: string) => void,
  handleSave: (params: Object) => Promise<void>,
  handleEdit: (e: SyntheticEvent<HTMLElement>) => void,
  id: number,
  deleted?: boolean,
  title: string,
  checked: boolean,
  loading: boolean,
  error: string,
  locked: boolean,
  lang: Lang,
  deleteDisabled: boolean,
  hasVendingMachine?: boolean
};

const tooltipDeleteVendingMachine = 'Точку продаж имеющую связь с вендинговым аппаратом запрещено удалять'

const Category = ({
  handleToggleItem,
  onDelete,
  onRestore,
  onSettings = () => { },
  handleSave,
  handleEdit,
  id,
  deleted,
  title,
  checked,
  loading,
  error,
  locked,
  lang,
  deleteDisabled,
  hasVendingMachine = false
}: Props) => (<div className={cx({ root: true, loading, active: checked })}>
  {!locked
    && <div className={styles.check}>
      <Tooltip text={hasVendingMachine ? tooltipDeleteVendingMachine : null} disableNoWrap>
        <PlainCheckbox
          label="title"
          onChange={handleToggleItem}
          checked={checked}
          value={id.toString()}
          disabled={loading || hasVendingMachine}
          hideLabel
        />
      </Tooltip>
    </div>}
  <div className={styles.name} style={{ minWidth: 0 }}>
    <div className={styles.titleWithIcon}>
      {hasVendingMachine && <IconVendingMachine className={styles.nameIcon} />}
      {(deleted || locked)
        ? <>
          <div className={styles.text}>{title}</div>
        </>
        : <EditableProp
          value={title}
          onSave={handleSave}
          name={id.toString()}
          errorText={error}
          onChange={handleEdit}
        />}
    </div>
  </div>
  {!locked
    && <div className={styles.control}>
      {!deleted && <PlainButtonAsLink onClick={() => onSettings(id, title)}>
        <Tooltip text="Настроить точку продаж">
          <IconSettings className={styles.iconSettings} />
        </Tooltip>
      </PlainButtonAsLink>}

      {!deleteDisabled && (deleted

        ? <ConfirmationDialog
          onConfirm={onRestore}
          text={lang.confirmRestoreText}
          confirmButtonText={lang.restoreButtonText}
          confirmParams={id}
        >
          <a href="restore">
            <Tooltip text={lang.tooltipRestoreText}><IconRecovery className={styles.icon} /></Tooltip>
          </a>
        </ConfirmationDialog>

        : <ConfirmationDialog
          onConfirm={onDelete}
          text={lang.confirmDeleteText}
          confirmButtonText={lang.removeButtonText}
          confirmParams={id}
        >
          {(handleConfirmation) => (
            <Tooltip text={hasVendingMachine ? tooltipDeleteVendingMachine : lang.tooltipDeleteText}>
              <span>
                <PlainButtonAsLink onClick={handleConfirmation} disabled={hasVendingMachine}>
                  <IconLightCross className={styles.icon} />
                </PlainButtonAsLink>
              </span>
            </Tooltip>
          )}
        </ConfirmationDialog>)}
    </div>}
</div>);

export default enhanceCategory(Category);
